// TODO this needs reworking if a general accordion script is required. ATM only guaranteed to work in context of Staff Members block (needs reworking in general as recycled from elsewhere)
// TODO would be better if the iconCross stuff was in its own script

(function () {
    'use strict';

    var faqs = document.querySelectorAll('.js-faqs');
    var classFAQOpen = 'faqs__container--open';
    const js_iconCrossClass = 'js-iconCross';
    const iconCrossClass = 'iconCross--animate';

    faqs.forEach(function (faq) {
        var trigger = faq.querySelectorAll('.js-faq-trigger');

        trigger.forEach(function (trig) {
            var targetCont = faq.querySelector('.js-faq-target');

            trig.addEventListener('mousedown', function (e) {

                if (faq.classList.contains(classFAQOpen)) {
                    faq.classList.remove(classFAQOpen);
                    var closeHeight = 0;
                    targetCont.style.height = closeHeight + 'px';
                } else {
                    faq.classList.add(classFAQOpen);
                    var targetContInner = targetCont.querySelector('.js-faq-targetInner');
                    var targetContInnerHeight = targetContInner.clientHeight;
                    targetCont.style.height = targetContInnerHeight + 'px';
                }

                if (e.currentTarget.classList.contains(js_iconCrossClass)) {
                    if (e.currentTarget.classList.contains(iconCrossClass)) {
                        e.currentTarget.classList.remove(iconCrossClass);
                    } else {
                        e.currentTarget.classList.add(iconCrossClass);
                    }
                }



            });

            window.addEventListener('resize', function () {
                if (faq.classList.contains(classFAQOpen)) {
                    var targetContInner = targetCont.querySelector('.js-faq-targetInner');
                    var targetContInnerHeight = targetContInner.clientHeight;
                    targetCont.style.height = targetContInnerHeight + 'px';
                }
            });
        });
    });
})();